document.addEventListener('DOMContentLoaded', function () {
    var drawerBtn = document.querySelector('.drawer_open');
    var aside = document.querySelector('aside');

    if (drawerBtn && aside) {
        drawerBtn.addEventListener('click', function () {
            drawerBtn.classList.toggle('is_open');
            aside.classList.toggle('is_open');
        });
    }
});
